'use strict';

var _ = require('lodash');
var GridRowSelectionButtonsController = function GridRowSelectionButtonsController($scope, $rootScope, toolbarNextPreviousButtonService, gridRecordsNavigationService, $q) {
  var gridPanel = $scope.gridPanelScope;
  var gridData;
  $scope.gridPanelId = gridPanel.gridId;
  $scope.previousKeyTooltip = toolbarNextPreviousButtonService.getLeftToolTip(gridPanel.gridId);
  $scope.nextKeyTooltip = toolbarNextPreviousButtonService.getRightToolTip(gridPanel.gridId);
  $scope.buttonState = {
    disablePreviousKeyButton: false,
    disablePreviousRowButton: false,
    disableNextRowButton: false,
    disableNextKeyButton: false
  };
  $scope.onDataUpdated = function (dataLoaded) {
    if (!dataLoaded) {
      return;
    }
    gridData = gridPanel.getDisplayRows();
    $scope.allRowFilters = gridPanel.getDisplayRowFilters();
    $scope.determineButtonsVisibility();
    $scope.updateGridTitle();
  };
  $scope.onDataSortUpdated = function (dataUpdated) {
    $scope.onDataUpdated(dataUpdated);
    gridPanel.resetGridDataUpdated();
  };
  $scope.onRowSelectionChange = function (selectedRows, gridId, allRows, selectedRowIndexes, selectionFilters, visibleRowProperties) {
    $scope.gridId = gridId;
    $scope.selectedRowIndexes = visibleRowProperties && visibleRowProperties.displayRowIndexes;
    $scope.selectionFilters = visibleRowProperties && visibleRowProperties.displayRowFilters;
    $scope.allRowFilters = visibleRowProperties && visibleRowProperties.allRowFilters;
    gridData = visibleRowProperties && visibleRowProperties.displayRows;
    $scope.rowKey = toolbarNextPreviousButtonService.getRowKeyId(gridPanel.gridId);
    $scope.determineButtonsVisibility();
    if (gridData && gridData.length > 0) {
      if (!gridRecordsNavigationService.isDemandManagementGrid($scope.gridId)) {
        $scope.updateGridTitle();
      }
    }
  };
  $scope.$on('grid:gridTitleUpdate', function () {
    $scope.buttonState = gridRecordsNavigationService.buttonState(gridData, $scope.selectedRowIndexes, $scope.rowKey, $scope.gridId, $scope.selectionFilters, $scope.allRowFilters);
    gridPanel.gridTitle = gridRecordsNavigationService.getDMParentTabTitle();
  });
  $scope.updateGridTitle = function () {
    if (!gridRecordsNavigationService.isDemandManagementGrid($scope.gridId)) {
      if (gridRecordsNavigationService.isParentTab($scope.gridId)) {
        gridPanel.gridTitle = toolbarNextPreviousButtonService.getGridTitle(gridPanel.gridId, gridData, $scope.selectionFilters, $scope.selectedRowIndexes);
        gridRecordsNavigationService.setParentTabTitle(gridPanel.gridTitle);
        return;
      }
      gridPanel.gridTitle = gridRecordsNavigationService.getParentTabTitle();
    }
  };
  $scope.determineButtonsVisibility = function () {
    $scope.buttonState = gridRecordsNavigationService.buttonState(gridData, $scope.selectedRowIndexes, $scope.rowKey, $scope.gridId, $scope.selectionFilters, $scope.allRowFilters);
  };
  $scope.moveToPreviousRow = function () {
    var previousRowIndex = gridRecordsNavigationService.getPreviousRowIndex($scope.selectedRowIndexes);
    clearAndSelectRowsWithinGrid([gridData[previousRowIndex]]);
  };
  $scope.moveToNextRow = function () {
    var nextRowIndex = gridRecordsNavigationService.getNextRowIndex(gridData, $scope.selectedRowIndexes);
    clearAndSelectRowsWithinGrid([gridData[nextRowIndex]]);
  };
  function childTabPreviousKeyNavigation(isMultipleKeySelected) {
    if (isMultipleKeySelected === undefined || isMultipleKeySelected) {
      withInGridPreviousKeyNavigation();
    } else {
      $scope.$emit('grid:selectPreviousKey', $scope.gridId);
    }
  }
  $scope.moveToPreviousKey = function () {
    if (gridRecordsNavigationService.isDemandManagementGrid($scope.gridId)) {
      childTabPreviousKeyNavigation(gridRecordsNavigationService.isDMParentMultipleKeySelected());
    } else {
      if (!gridRecordsNavigationService.isParentTab($scope.gridId)) {
        childTabPreviousKeyNavigation(gridRecordsNavigationService.isParentMultipleKeySelected());
      } else {
        if ($scope.selectedRowIndexes === undefined) {
          $scope.selectedRowIndexes = [0];
        }
        withInGridPreviousKeyNavigation();
      }
    }
  };
  function childTabNextKeyNavigation(isMultipleKeySelected, emitAfterMoving) {
    if (isMultipleKeySelected === undefined || isMultipleKeySelected) {
      withInGridNextKeyNavigation(emitAfterMoving);
    } else {
      $scope.$emit('grid:selectNextKey', $scope.gridId);
    }
  }
  $scope.moveToNextKey = function (event, emitAfterMoving) {
    if (gridRecordsNavigationService.isDemandManagementGrid($scope.gridId)) {
      childTabNextKeyNavigation(gridRecordsNavigationService.isDMParentMultipleKeySelected());
    } else {
      if (!gridRecordsNavigationService.isParentTab($scope.gridId)) {
        childTabNextKeyNavigation(gridRecordsNavigationService.isParentMultipleKeySelected(), emitAfterMoving);
      } else {
        if ($scope.selectedRowIndexes === undefined) {
          $scope.selectedRowIndexes = [0];
        }
        withInGridNextKeyNavigation(emitAfterMoving);
      }
    }
  };
  function getGridDataState() {
    var displayedRows = $scope.gridPanelScope.syncGridApply('getdisplayrows');
    var selectedRowIndexes = $scope.gridPanelScope.syncGridApply('selectedrowindexes');
    return {
      displayedRows: displayedRows,
      selectedRowIndexes: processIndexes(displayedRows, selectedRowIndexes)
    };
  }
  function processIndexes(displayedRows, selectedRowIndexes) {
    return _.chain(selectedRowIndexes).map(function (rowIndexInLocalData) {
      return _.findIndex(displayedRows, {
        uid: rowIndexInLocalData
      });
    }).filter(function (elementIndex) {
      return elementIndex > -1;
    }).sortBy().value();
  }
  function withInGridNextKeyNavigation(emitAfterMoving) {
    var gridDataState = getGridDataState();
    var nextKeyIndex = gridRecordsNavigationService.getNextKeyIndex(gridDataState.selectedRowIndexes, $scope.rowKey, gridDataState.displayedRows);
    var isLastKey = false;
    if (nextKeyIndex > gridData.length - 1) {
      $scope.$emit('grid:selectNextKey', $scope.gridId, emitAfterMoving);
      isLastKey = true;
    } else {
      clearAndSelectRowsWithinGrid([gridDataState.displayedRows[nextKeyIndex]], emitAfterMoving);
    }
    $rootScope.$broadcast('grid:onSelectedNextKey', $scope.gridId, isLastKey);
  }
  function withInGridPreviousKeyNavigation() {
    var gridDataState = getGridDataState();
    var previousKeyIndex = gridRecordsNavigationService.getPreviousKeyIndex(gridDataState.selectedRowIndexes, $scope.rowKey, gridDataState.displayedRows);
    var isFirstKey = false;
    if (previousKeyIndex < 0) {
      $scope.$emit('grid:selectPreviousKey', $scope.gridId);
      isFirstKey = true;
    } else {
      clearAndSelectRowsWithinGrid([gridDataState.displayedRows[previousKeyIndex]]);
    }
    $rootScope.$broadcast('grid:onSelectedPrevKey', $scope.gridId, isFirstKey);
  }
  function clearAndSelectRowsWithinGrid(rows, emitAfterSelecting) {
    gridPanel.clearAndSelectRows(rows, emitAfterSelecting);
  }
};
GridRowSelectionButtonsController.$inject = ['$scope', '$rootScope', 'ToolbarNextPreviousButtonService', 'GridRecordsNavigationService', '$q'];
module.exports = GridRowSelectionButtonsController;